import { useCallback, useEffect, useState } from 'react'

import { useDebouncedCallback } from 'use-debounce'

const inputs = ['input', 'select', 'textarea']

interface ScannerProps {
  onScan?: (guid: string) => void
  onCommand?: (command: string, data?: any) => void
}

export const Scanner = (props: ScannerProps) => {
  const { onScan, onCommand } = props
  const [value, setValue] = useState<string[]>([])

  const resetAfterDelay = useDebouncedCallback(() => setValue([]), 500)

  const registerKey = useCallback(
    (code: number) => {
      if (code === 13) {
        if (value.length) {
          resetAfterDelay.cancel()
          if (onScan) {
            onScan(value.join(''))
          }
          setValue([])
        }
      } else {
        value.push(String.fromCharCode(code))
        resetAfterDelay.callback()
      }
    },
    [onScan, resetAfterDelay, value]
  )

  const onKeyPress = useCallback(
    (e: KeyboardEvent) => {
      if (inputs.indexOf(document.activeElement?.tagName.toLowerCase() || '') === -1) {
        registerKey(e.keyCode)
      }
    },
    [registerKey]
  )

  const onPasted = useCallback(
    (e: ClipboardEvent) => {
      const pastedText = e?.clipboardData?.getData('text')
      if (
        pastedText !== undefined &&
        pastedText !== null &&
        onScan &&
        inputs.indexOf(document.activeElement?.tagName.toLowerCase() || '') === -1
      ) {
        onScan(pastedText)
      }
    },
    [onScan]
  )

  const processCommand = useCallback(
    (event: CustomEvent) => {
      onCommand?.(event.detail.command, event.detail.data)
    },
    [onCommand]
  )

  useEffect(() => {
    window.addEventListener('keypress', onKeyPress)
    return () => {
      window.removeEventListener('keypress', onKeyPress)
    }
  }, [value, onKeyPress])

  useEffect(() => {
    window.addEventListener('paste', onPasted as EventListener)

    return () => {
      window.removeEventListener('paste', onPasted as EventListener)
    }
  }, [onPasted])

  useEffect(() => {
    window.addEventListener('skuitCommand', processCommand as EventListener)

    return () => {
      window.removeEventListener('found', processCommand as EventListener)
    }
  }, [processCommand])
  return null
}
